import { render, staticRenderFns } from "./BudgetProject.vue?vue&type=template&id=7f3c9411&scoped=true"
import script from "./BudgetProject.vue?vue&type=script&lang=js"
export * from "./BudgetProject.vue?vue&type=script&lang=js"
import style0 from "./BudgetProject.vue?vue&type=style&index=0&id=7f3c9411&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3c9411",
  null
  
)

export default component.exports